import type { WidgetConfig, FeedResponse, ItemResponse, ApiError } from './types.js';

export async function fetchFeed(feedUrl: string, config: WidgetConfig): Promise<FeedResponse> {
  const url = `${config.apiBase}/v1/feed?url=${encodeURIComponent(feedUrl)}&maxItems=${config.maxItems}`;
  return request<FeedResponse>(url);
}

export async function fetchItem(feedUrl: string, itemId: string, config: WidgetConfig): Promise<ItemResponse> {
  const url = `${config.apiBase}/v1/item?url=${encodeURIComponent(feedUrl)}&id=${encodeURIComponent(itemId)}`;
  return request<ItemResponse>(url);
}

async function request<T>(url: string): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10_000);

  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) {
      const text = await response.text().catch(() => '');
      let body: any;
      try {
        body = JSON.parse(text);
      } catch {
        body = { error: { code: 'UNKNOWN', message: text || 'Unknown error' } };
      }
      const error: ApiError = {
        status: response.status,
        code: body.error?.code ?? 'UNKNOWN',
        message: body.error?.message ?? body.message ?? 'Unknown error',
      };
      console.error(`[rss-widget] ${error.code} (HTTP ${response.status}):`, error.message);
      throw error;
    }
    return (await response.json()) as T;
  } catch (err) {
    if ((err as ApiError).status) throw err;
    console.error('[rss-widget] Request failed:', err);
    throw {
      status: 0,
      code: 'NETWORK_ERROR',
      message: 'Network request failed',
    } as ApiError;
  } finally {
    clearTimeout(timer);
  }
}
